export const LOCATION_HASH = '#search';
